import { render, staticRenderFns } from "./ViewEdit.vue?vue&type=template&id=630282b2"
import script from "./ViewEdit.vue?vue&type=script&lang=ts"
export * from "./ViewEdit.vue?vue&type=script&lang=ts"
import style0 from "./ViewEdit.vue?vue&type=style&index=0&id=630282b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports